import React from "react";
import "./LandingPageBanner.css";
import UpdatesBanner from "../../UpdatesBanner/UpdatesBanner";
export default function LandingPageBanner() {
 return (
  <UpdatesBanner
    className="container-banner"
    bannerTitle={[
      "Every agrifood organisation will become an ecosystem network operator.",
      "The ones who own & operate it will define the market."
    ]}
    bannerbodycopy1={[
      "GBR Farming makes it possible—by enabling agrifood organisation to own, orchestrate, and scale their ecosystems.",
    ]}
    buttonText1="Book Demo"
    href1="/book-demo"
 /*    href6="/ComingSoon"
    buttonText6="Meet The Team" */
  />
);
}
